import React from 'react'
import { Card, TextField, CardContent, Button, FormControl, Grid } from '@mui/material';

import { LinearLoading } from '../../../../common'

export const OrigenesForm = ({ useFetchInit }) => {

    const {
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputChange } = FormScreen
    
    const { fetchSpecificOrigen } = FetchData
    const { loadingFetchSpecificOrigen } = fetchSpecificOrigen

    const { onSubmitForm, handleClickHideForm } = Actions

    return (
        <div className='content'>
            <Card style={{zIndex:'1'}}>
                <CardContent>
                    <div className='h4 mt-1 mb-1'>
                        {formState.idorigen > 0
                            ? 'Actualizar Registro'
                            : 'Crear Registro'}
                    </div>
                    <div className="border-bottom border-dark"></div>
                    {loadingFetchSpecificOrigen && ( <LinearLoading /> )}

                    <div className="pt-3"></div>
                    <p className='text-danger'>* campos obligatorios</p>
                    <div className="pt-2"></div>

                    <form onSubmit={onSubmitForm}>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombre"
                                        name="nombre"
                                        value={formState.nombre}
                                        onChange={onInputChange}
                                        label='Nombre'
                                        size='small'
                                        type="text"
                                        variant="standard"
                                        // hiddenLabel
                                        InputProps={{
                                            readOnly: false,
                                        }}
                                        required
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                        <div className="pt-4"></div>
                        <Grid container>
                            <Grid item>
                                <div className='update ml-auto mr-auto'>
                                    <Button
                                        style={{background: "#4b4b4c"}}
                                        variant="contained"
                                        type='submit'
                                    >
                                        <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                    </Button>
                                    &nbsp; &nbsp;
                                    <Button
                                        style={{ marginRight: 2, marginLeft: 2, background: "#ef8157" }}
                                        type='button'
                                        variant="contained"
                                        onClick={handleClickHideForm}
                                    >
                                        <i className="fa-regular fa-circle-left"></i> &nbsp; Cancelar
                                    </Button>
                                </div>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>
        </div>
    )
}
